import React, {Component} from 'react';
import {
    getDataByDataSourceType,
    DATA_SOURCE_TYPE_BUSINESS_UNITS,
    DATA_SOURCE_TYPE_AD_ACCOUNTS
} from "../../nodeToGSheet";
import {ALL_PERIODS, getPropertiesForPeriod, getPeriodName} from "../../periods";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {Switch} from "../buttons/Swtich";
import {FaIcon} from "../FaIcon";
import {ActiveColumnsList} from "../dashboard/ActiveColumnsList";
import { withTranslation } from 'react-i18next';
import { NodeHelper } from '../../utils/NodeHelper';
import { DimensionsFiltersComponent } from '../data_explorer/DimensionsFiltersComponent';
import { getFieldDescriptionKey, hasFieldDescription } from '../../utils/fieldDescriptions';
import { FieldHelpIcon } from '../elements/FieldHelpIcon';

class SyncConfigurationFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            loading: true,
            isEditing: !!this.props.syncConfiguration && !this.props.isCopying,
            isCopying: !!this.props.isCopying,

            agencyClients: [],
            fieldsData: null,
            businessUnits: [],
            adAccounts: [],

            agencyClientId: '',
            sourceType: DATA_SOURCE_TYPE_BUSINESS_UNITS,
            period: '',
            spreadsheetId: '',
            sheetName: '',
            selectedBusinessUnitIdOrAccountIdentifier: '',

            dimensions: [],
            metrics: [],

            spreadsheetStatus: 'unchecked',
            spreadsheetErrorMessage: '',
            dimensionsFilters: [], // Filtros de dimensiones en formato Looker Studio
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.verifySpreadsheet = this.verifySpreadsheet.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleDimensionsOrderChange = this.handleDimensionsOrderChange.bind(this);
        this.handleMetricsOrderChange = this.handleMetricsOrderChange.bind(this);
        this.handleDimensionsFiltersChange = this.handleDimensionsFiltersChange.bind(this);
    }

    componentDidMount() {
        const url = API_URL + 'node-to-gsheet/sync-configuration/form-data';
        new APIClient(url).call('GET').then((data) => {
            if (data.agency_clients && data.fields_data) {
                this.setState({
                    loading: false,
                    agencyClients: data.agency_clients,
                    fieldsData: data.fields_data,
                    businessUnits: data.business_units || [],
                    adAccounts: data.ad_accounts || []
                }, () => {
                    if (this.state.isEditing || this.state.isCopying) {
                        this.populateFormForEditing();
                    }
                });
            } else {
                console.error("Incomplete data from form-data endpoint", data);
                this.setState({loading: false});
                const { t } = this.props;
                alert(t('sync_configuration_form.error_could_not_load_form_configuration'));
            }
        }).catch(error => {
            this.setState({loading: false});
            const { t } = this.props;
            alert(t('sync_configuration_form.error_loading_form_configuration'));
        });
    }

    populateFormForEditing() {
        const { syncConfiguration } = this.props;
        if (!syncConfiguration) return;

        const { data_request } = syncConfiguration;
        if (!data_request) return;

        const { fieldsData } = this.state;
        const allFieldIds = data_request.fields_json.map(f => f.name);

        const dimensions = allFieldIds.filter(id => fieldsData.FIELD_DATA_BY_ID[id] && fieldsData.FIELD_DATA_BY_ID[id].type === fieldsData.FIELD_TYPES.DIMENSION);
        const metrics = allFieldIds.filter(id => fieldsData.FIELD_DATA_BY_ID[id] && fieldsData.FIELD_DATA_BY_ID[id].type === fieldsData.FIELD_TYPES.METRIC);
        const selectedBusinessUnitIdOrAccountIdentifier = this.getSelectedBusinessUnitIdOrAccountIdentifierFromDimensionsFilters(data_request);
        
        // Extraer filtros personalizados (excluyendo BusinessUnitId, Channel, AccountId)
        const dimensionsFilters = Array.isArray(data_request.dimensions_filters_json) ? data_request.dimensions_filters_json : [];
        const customFilters = dimensionsFilters.filter(filterGroup => {
            // Verificar si el grupo contiene solo filtros básicos
            return filterGroup.some(filter => {
                const fieldName = filter.fieldName;
                return fieldName !== NodeHelper.BUSINESS_UNIT_ID_FIELD_ID &&
                       fieldName !== NodeHelper.CHANNEL_FIELD_ID &&
                       fieldName !== NodeHelper.ACCOUNT_ID_FIELD_ID;
            });
        });

        this.setState({
            agencyClientId: this.state.isCopying ? '' : syncConfiguration.agency_client.id,
            sourceType: data_request.data_source_type,
            period: data_request.period,
            spreadsheetId: this.state.isCopying ? '' : syncConfiguration.google_spreadsheet_id,
            sheetName: this.state.isCopying ? '' : syncConfiguration.google_sheet_name,
            dimensions: dimensions,
            metrics: metrics,
            spreadsheetStatus: this.state.isCopying ? 'unchecked' : 'ok',
            selectedBusinessUnitIdOrAccountIdentifier: selectedBusinessUnitIdOrAccountIdentifier,
            dimensionsFilters: customFilters
        });
    }

    convertAccountDataToSelectId(accountData) {
        return this.convertAccountValuesToSelectId(accountData.channel, accountData.account_id);
    }

    convertAccountValuesToSelectId(channel, accountId) {
        return `${channel}__${accountId}`;
    }

    getChannelFromAccountIdentifier(accountIdentifier) {
        if(!accountIdentifier)
            return null;
        
        return accountIdentifier.split('__')[0];
    }
    
    getAccountIdFromAccountIdentifier(accountIdentifier) {
        if(!accountIdentifier)
            return null;
        
        return accountIdentifier.split('__')[1];
    }

    getSelectedBusinessUnitIdOrAccountIdentifierFromDimensionsFilters(data_request) {
        const dimensionsFiltersGroups = data_request.dimensions_filters_json;
        const idsForFormFilters = NodeHelper.convertDimensionsFiltersToSelectedBusinessUnitIdOrChannelAndAccountId(dimensionsFiltersGroups);
        if(data_request.data_source_type === DATA_SOURCE_TYPE_BUSINESS_UNITS) {
            return idsForFormFilters.businessUnitId ? idsForFormFilters.businessUnitId.toString() : '';
        } else if(data_request.data_source_type === DATA_SOURCE_TYPE_AD_ACCOUNTS) {
            return idsForFormFilters.accountId && idsForFormFilters.channel ? this.convertAccountValuesToSelectId(idsForFormFilters.channel, idsForFormFilters.accountId) : '';
        }
        return '';
    }

    hasToSelectPeriod() {
        const { fieldsData, metrics } = this.state;
        return metrics.filter(id => fieldsData.FIELD_DATA_BY_ID[id] && fieldsData.FIELD_DATA_BY_ID[id].depends_on_daterange === true).length > 0;
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        if (name === 'sourceType') {
            const { fieldsData } = this.state;
            if (fieldsData && fieldsData.FIELDS_BY_DATA_SOURCE_TYPE) {
                const validFieldIds = fieldsData.FIELDS_BY_DATA_SOURCE_TYPE[value] || [];
                this.setState(prevState => ({
                    sourceType: value,
                    dimensions: prevState.dimensions.filter(d => validFieldIds.includes(d)),
                    metrics: prevState.metrics.filter(m => validFieldIds.includes(m)),
                    selectedBusinessUnitIdOrAccountIdentifier: '',
                }));
            } else {
                this.setState({ [name]: value, selectedBusinessUnitIdOrAccountIdentifier: '' });
            }
        } else if (name === 'agencyClientId') {
            this.setState({
                [name]: value,
                selectedBusinessUnitIdOrAccountIdentifier: ''
            });
        } else if (name === 'spreadsheetId' || name === 'sheetName') {
            this.setState({
                [name]: value,
                spreadsheetStatus: 'unchecked',
                spreadsheetErrorMessage: ''
            });
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    getSelectedBusinessUnitIdFromForm() {
        if(this.state.sourceType !== DATA_SOURCE_TYPE_BUSINESS_UNITS)
            return null;
        
        if(!this.state.selectedBusinessUnitIdOrAccountIdentifier)
            return null;
        
        return parseInt(this.state.selectedBusinessUnitIdOrAccountIdentifier, 10);
    }

    getSelectedChannelFromForm() {
        if(this.state.sourceType !== DATA_SOURCE_TYPE_AD_ACCOUNTS)
            return null;
        
        if(!this.state.selectedBusinessUnitIdOrAccountIdentifier)
            return null;
        
        return this.getChannelFromAccountIdentifier(this.state.selectedBusinessUnitIdOrAccountIdentifier);
    }

    getSelectedAccountIdFromForm() {
        if(this.state.sourceType !== DATA_SOURCE_TYPE_AD_ACCOUNTS)
            return null;
        
        if(!this.state.selectedBusinessUnitIdOrAccountIdentifier)
            return null;
        
        return parseInt(this.getAccountIdFromAccountIdentifier(this.state.selectedBusinessUnitIdOrAccountIdentifier), 10);
    }

    handleDimensionsFiltersChange(newFilters) {
        this.setState({ dimensionsFilters: newFilters });
    }

    getDimensionsFiltersForPost() {
        // Combinar los filtros básicos (BusinessUnitId, Channel, AccountId) con los filtros personalizados
        const filtersGroups = [];

        const business_unit_id = this.getSelectedBusinessUnitIdFromForm();
        const channel = this.getSelectedChannelFromForm();
        const account_id = this.getSelectedAccountIdFromForm();

        if(business_unit_id) {
            filtersGroups.push([{
                'fieldName': NodeHelper.BUSINESS_UNIT_ID_FIELD_ID,
                'values': [business_unit_id],
                'type': NodeHelper.FILTER_TYPE_INCLUDE,
                'operator': NodeHelper.FILTER_OPERATOR_EQUALS
            }]);
        }
        if(channel) {
            filtersGroups.push([{
                'fieldName': NodeHelper.CHANNEL_FIELD_ID,
                'values': [channel],
                'type': NodeHelper.FILTER_TYPE_INCLUDE,
                'operator': NodeHelper.FILTER_OPERATOR_EQUALS
            }]);
        }
        if(account_id) {
            filtersGroups.push([{
                'fieldName': NodeHelper.ACCOUNT_ID_FIELD_ID,
                'values': [account_id],
                'type': NodeHelper.FILTER_TYPE_INCLUDE,
                'operator': NodeHelper.FILTER_OPERATOR_EQUALS
            }]);
        }

        // Agregar los filtros personalizados del componente
        if (this.state.dimensionsFilters && this.state.dimensionsFilters.length > 0) {
            filtersGroups.push(...this.state.dimensionsFilters);
        }
       
        return filtersGroups;
    }

    handleSubmit(event) {
        event.preventDefault();


        this.setState({saving: true});

        const spreadsheetId = this.getSpreadsheetId(this.state.spreadsheetId);
        const endpoint = this.state.isEditing
            ? `node-to-gsheet/sync-configuration/${this.props.syncConfiguration.id}/update`
            : 'node-to-gsheet/sync-configuration/create';

        const url = API_URL + endpoint;

        const allFields = [...this.state.dimensions, ...this.state.metrics];
        const fields_json = allFields.map(fieldId => ({ name: fieldId }));

        const data = {
            'agency_client_id': this.state.agencyClientId,
            'spreadsheetId': spreadsheetId,
            'sheetName': this.state.sheetName,
            'sourceType': this.state.sourceType,
            'period': this.state.period,
            'fields_json': fields_json,
            'dimensions_filters_json': this.getDimensionsFiltersForPost()
        };

        new APIClient(url).call('POST', data).then((response) => {
            this.setState({saving: false});
            if (response.status === 'ERROR' || response.status === 'GSHEET_NO_ACCESS' || response.status === 'GSHEET_SHEET_NOT_FOUND') {
                if (response.status === 'GSHEET_NO_ACCESS' || response.status === 'GSHEET_SHEET_NOT_FOUND') {
                    this.setState({
                        spreadsheetStatus: 'error',
                        spreadsheetErrorMessage: response.error_message
                    });
                }
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.props.afterSubmit();
            }
        }).catch(err => {
            this.setState({saving: false});
             console.error(err);
            const { t } = this.props;
            alert(t('sync_configuration_form.error_occurred_while_saving'));
        });
    }
    
    getSpreadsheetId(input) {
        if (!input) return '';
        if (input.startsWith('https://')) {
            const match = input.match(/\/d\/(.*?)\//);
            if (match && match[1]) {
                return match[1];
            }
        }
        return input;
    }

    verifySpreadsheet() {
        const spreadsheetId = this.getSpreadsheetId(this.state.spreadsheetId);
        if (!spreadsheetId) {
            const { t } = this.props;
            alert(t('sync_configuration_form.please_enter_spreadsheet_id_or_url'));
            return;
        }
        this.setState({spreadsheetStatus: 'verifying', spreadsheetErrorMessage: ''});
        const url = API_URL + 'node-to-gsheet/verify-spreadsheet';
        new APIClient(url).call('POST', {id: spreadsheetId, sheet_name: this.state.sheetName}).then(data => {
            if (data.status === 'OK') {
                this.setState({spreadsheetStatus: 'ok'});
            } else {
                this.setState({spreadsheetStatus: 'error', spreadsheetErrorMessage: data.error_message});
            }
        }).catch(error => {
            const { t } = this.props;
            this.setState({spreadsheetStatus: 'error', spreadsheetErrorMessage: t('sync_configuration_form.network_error')});
        });
    }

    renderSpreadsheetStatus() {
        const { t } = this.props;
        switch (this.state.spreadsheetStatus) {
            case 'verifying':
                return <Spinner color="primary small" />;
            case 'ok':
                return <span style={{color: 'green'}}><FaIcon iconName="check-circle" /> {t('sync_configuration_form.successful_connection')}</span>;
            case 'error':
                return <span style={{color: 'red'}}><FaIcon iconName="exclamation-circle" /> {this.state.spreadsheetErrorMessage}</span>;
            default:
                return null;
        }
    }

    handleFieldChange(event) {
        const target = event.target;
        const [fieldType, fieldId] = target.name.split('#');
        const isChecked = target.checked;

        const stateKey = fieldType === 'DIMENSION' ? 'dimensions' : 'metrics';

        this.setState(prevState => {
            const currentFields = prevState[stateKey];
            if (isChecked) {
                return {[stateKey]: [...currentFields, fieldId]};
            } else {
                return {[stateKey]: currentFields.filter(id => id !== fieldId)};
            }
        });
    }
    
    handleDimensionsOrderChange(newOrder) {
        this.setState({ dimensions: newOrder });
    }

    handleMetricsOrderChange(newOrder) {
        this.setState({ metrics: newOrder });
    }

    renderItemSelector() {
        const { t } = this.props;
        const { sourceType, agencyClientId, businessUnits, adAccounts, selectedBusinessUnitIdOrAccountIdentifier } = this.state;

        if (sourceType === DATA_SOURCE_TYPE_BUSINESS_UNITS) {
            const businessUnitsOfClient = agencyClientId 
                ? businessUnits.filter(bu => bu.agency_client_id.toString() === agencyClientId.toString())
                : [];
            return (
                <React.Fragment>
                    <label>{t('sync_config.business_unit_label', 'Línea de control')}</label>
                    <select name="selectedBusinessUnitIdOrAccountIdentifier" value={selectedBusinessUnitIdOrAccountIdentifier} onChange={this.handleChange}>
                        <option value="">{t('sync_config.all_business_units_option', 'Todas las líneas de control del cliente')}</option>
                        {businessUnitsOfClient.map(bu => (
                            <option key={bu.id} value={bu.id}>{bu.name}</option>
                        ))}
                    </select>
                </React.Fragment>
            );
        }

        if (sourceType === DATA_SOURCE_TYPE_AD_ACCOUNTS) {
            const adAccountsOfClient = agencyClientId 
                ? adAccounts.filter(aa => aa.agency_client_id.toString() === agencyClientId.toString())
                : [];
            return (
                <React.Fragment>
                    <label>{t('sync_config.ad_account_label', 'Cuenta publicitaria')}</label>
                    <select name="selectedBusinessUnitIdOrAccountIdentifier" value={selectedBusinessUnitIdOrAccountIdentifier} onChange={this.handleChange}>
                        <option value="">{t('sync_config.all_ad_accounts_option', 'Todas las cuentas del cliente')}</option>
                        {adAccountsOfClient.map(aa => (
                            <option key={this.convertAccountValuesToSelectId(aa.channel, aa.account_id)} value={this.convertAccountValuesToSelectId(aa.channel, aa.account_id)}>{aa.name} (Id: {aa.account_id}) ({aa.channel})</option>
                        ))}
                    </select>
                </React.Fragment>
            );
        }

        return null;
    }

    renderFieldChoice(fieldType, field) {
        const selectedFields = fieldType === 'DIMENSION' ? this.state.dimensions : this.state.metrics;
        const isChecked = selectedFields.includes(field.id);
        
        return (
            <div key={field.id} className="form-item -inline">
                <Switch checked={isChecked}
                        name={`${fieldType}#${field.id}`}
                        onChange={this.handleFieldChange}/>
                <div className="combined-label">
                    <p className="combined-label-title">
                        {field.name}
                        <FieldHelpIcon fieldId={field.id} />
                    </p>
                </div>
            </div>
        );
    }
    
    renderFieldsSection(title, fieldSegment) {
        if (!this.state.fieldsData) return null;

        const { FIELDS_BY_DATA_SOURCE_TYPE, FIELD_DATA_BY_ID, FIELD_SEGMENTS, FIELDS_GROUP_DATA } = this.state.fieldsData;
        if (!FIELDS_BY_DATA_SOURCE_TYPE || !FIELD_DATA_BY_ID || !FIELD_SEGMENTS || !FIELDS_GROUP_DATA) return null;

        const availableFieldIds = FIELDS_BY_DATA_SOURCE_TYPE[this.state.sourceType];
        if (!availableFieldIds) {
            const { t } = this.props;
            return <p>{t('sync_configuration_form.select_modality_to_see_available_fields')}</p>;
        }

        const fieldsByGroup = {};
        Object.keys(FIELDS_GROUP_DATA).forEach(groupId => {
            fieldsByGroup[groupId] = [];
        });

        availableFieldIds.forEach(id => {
            const field = FIELD_DATA_BY_ID[id] ? { ...FIELD_DATA_BY_ID[id], id } : null;
            if (field && field.segment === FIELD_SEGMENTS[fieldSegment] && field.group) {
                if (fieldsByGroup[field.group]) {
                    fieldsByGroup[field.group].push(field);
                }
            }
        });

        return (
            <div className="modal-section pt-0">
                <div className="form-header">
                    <h3 className="form-title" style={{color: '#343a40', fontWeight: 600}}>
                        {title}
                    </h3>
                </div>
                {Object.entries(FIELDS_GROUP_DATA).map(([groupId, groupData]) => {
                    const groupFields = fieldsByGroup[groupId];
                    if (!groupFields || groupFields.length === 0) {
                        return null;
                    }
                    return (
                        <div key={groupId} style={{marginBottom: '20px'}}>
                            <h4 style={{fontSize: '1rem', color: '#6c757d', fontWeight: 400, borderBottom: '1px solid #eee', paddingBottom: '5px', marginBottom: '15px'}}>
                                {groupData.name}
                            </h4>
                            <div className={"form-grid row-col-2"}>
                                {groupFields.map(field => this.renderFieldChoice(field.type, field))}
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }

    getFieldDataForActiveList(fieldId) {
        const { t } = this.props;
        const fieldData = this.state.fieldsData && this.state.fieldsData.FIELD_DATA_BY_ID && this.state.fieldsData.FIELD_DATA_BY_ID[fieldId];
        const title = fieldData ? fieldData.name : fieldId;
        const descriptionKey = getFieldDescriptionKey(fieldId);
        
        return { 
            title,
            descriptionKey: descriptionKey ? t(descriptionKey) : null,
            hasDescription: hasFieldDescription(fieldId)
        };
    }

    renderSaveButton() {
        const { t } = this.props;
        if (!this.state.saving) {
            let buttonText = t('sync_configuration_form.create');
            if (this.state.isEditing) {
                buttonText = t('sync_configuration_form.save_changes');
            } else if (this.state.isCopying) {
                buttonText = t('sync_configuration_form.create_copy');
            }
            return <input type="submit" value={buttonText} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Spinner/>
        }
        
        const availablePeriods = ALL_PERIODS.filter(p => getPropertiesForPeriod(t)[p] && !getPropertiesForPeriod(t)[p].depends_of_other_period);

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="modal-section">
                    <div className="form-row">
                        <label>{t('sync_config.client_label')}</label>
                        <select name="agencyClientId" value={this.state.agencyClientId} onChange={this.handleChange} required>
                            <option value="">{t('sync_config.select_client_option')}</option>
                            {this.state.agencyClients.filter(client => client.is_active).map(client => (
                                <option key={client.id} value={client.id}>{client.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-row" style={{display: 'flex', gap: '1rem', alignItems: 'flex-end'}}>
                        <div style={{flex: 1}}>
                            <label>{t('sync_config.modality_label')}</label>
                            <select name="sourceType" value={this.state.sourceType} onChange={this.handleChange}>
                                {Object.keys(getDataByDataSourceType(t)).map(sourceType => (
                                    <option key={sourceType} value={sourceType}>
                                        {getDataByDataSourceType(t)[sourceType]}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{flex: 1}}>
                            {this.renderItemSelector()}
                        </div>
                    </div>
                    <div className="form-row">
                        <label>{t('sync_config.period_label')}</label>
                        <select name="period" value={this.state.period} onChange={this.handleChange} required={this.hasToSelectPeriod()}>
                            <option value="">{t('sync_config.select_period_option')}</option>
                            {availablePeriods.map(period => (
                                <option key={period} value={period}>
                                    {getPeriodName(period, t)}
                                </option>
                            ))}
                        </select>
                    </div>
                    {this.state.fieldsData && (
                        <div className="form-row">
                            <label>{t('filters.filters_label', 'Filtros')}</label>
                            <DimensionsFiltersComponent
                                fieldsData={this.state.fieldsData}
                                sourceType={this.state.sourceType}
                                filters={this.state.dimensionsFilters}
                                onFiltersChange={this.handleDimensionsFiltersChange}
                            />
                        </div>
                    )}
                     <div className="form-row">
                        <label>{t('sync_config.spreadsheet_label')}</label>
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                            <input name="spreadsheetId" type="text" value={this.state.spreadsheetId} onChange={this.handleChange} style={{flexGrow: 2}} required placeholder={t('sync_config.spreadsheet_id_placeholder')} />
                            <input name="sheetName" type="text" value={this.state.sheetName} onChange={this.handleChange} style={{flexGrow: 1}} required placeholder={t('sync_config.sheet_name_placeholder')} />
                            <button type="button" onClick={this.verifySpreadsheet} className="btn -alt">{t('sync_config.verify_button')}</button>
                        </div>
                        <div style={{marginTop: '5px'}}>{this.renderSpreadsheetStatus()}</div>
                    </div>
                </div>

                <div className="d-flex">
                    <div style={{flex: 3, paddingRight: '15px'}}>
                        {this.renderFieldsSection(t('sync_configuration_form.dimensions'), 'DIMENSIONS')}
                        {this.renderFieldsSection(t('sync_configuration_form.indicators'), 'INDICATORS')}
                        {this.renderFieldsSection(t('sync_configuration_form.metrics'), 'METRICS')}
                    </div>
                    <div className='ps-2 pe-2' style={{flex: 2, paddingLeft: '15px', borderLeft: '1px solid #ddd'}}>
                        <div className="modal-aside">
                             <div className="form-header">
                                <h3 className="form-title">{t('sync_config.selected_dimensions_title')}</h3>
                            </div>
                            <ActiveColumnsList
                                activeColumns={this.state.dimensions}
                                onColumnsPositionChange={this.handleDimensionsOrderChange}
                                getColumnData={(id) => this.getFieldDataForActiveList(id)}
                            />
                            <div className="form-header" style={{marginTop: '20px'}}>
                                <h3 className="form-title">{t('sync_configuration_form.selected_metrics')}</h3>
                            </div>
                             <ActiveColumnsList
                                activeColumns={this.state.metrics}
                                onColumnsPositionChange={this.handleMetricsOrderChange}
                                getColumnData={(id) => this.getFieldDataForActiveList(id)}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="modal-footer">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export const SyncConfigurationForm = withTranslation()(SyncConfigurationFormComponent);
